import 'react';
import PropTypes from 'prop-types';

const CarouselItem = (props) => {
    const {
        logo,
        resortName,
        location,
        image,
        // price,
        description,
        link
    } = props;
    
    return (
        <div className="item">
            <i className={`ic ic-logo-${logo.toLowerCase()}`} />
            <h4 className="name">{resortName}</h4>
            <h4 className="location">{location}</h4>
            <figure>
                <img src={image} alt={resortName} className="img-responsive"/>
            </figure>
            <div className="item-bottom">
                {/* <div className="price">
                    Vacations from
                    <span className="value">${price}</span>
                    <small>PP/PN <span className="show">(USD)</span></small>
                </div> */}
                <p>{description}</p>
                <a href={link} className="link">View Resort</a>
            </div>
        </div>
    );
};

CarouselItem.propTypes = {
    logo: PropTypes.string,
    resortName: PropTypes.string,
    location: PropTypes.string,
    image: PropTypes.string,
    price: PropTypes.number,
    description: PropTypes.string,
    link: PropTypes.string
};

CarouselItem.defaultProps = {
    logo: '',
    resortName: '',
    location: '',
    image: '',
    price: 0,
    description: '',
    link: '#'
};

export default CarouselItem;
